import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import {
    DropdownType,
    horizontalCenter, horizontalJustify,
    horizontalDistribute,
    horizontalLeft,
    horizontalRight,

} from '@editor/src/js/constants/toolbar-data';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_DROPDOWN, TOOLBAR_H_ALIGN_LEFT } from '@editor/src/img/pageIndex';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import {
    AlignType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';

export const config = {
    id: ActionType.HORIZONTAL_ALIGN,
    tipMsg: i18n.t('水平对齐'),
    icon: TOOLBAR_H_ALIGN_LEFT,
    showSelectedValue: true,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.GRID,
        checkSelectedValue: true,
        columns: 1,
        data: [
            horizontalLeft,
            horizontalCenter,
            horizontalRight,
            horizontalJustify,
            horizontalDistribute,
        ],
    },
    twdConfig: {
        action: TDWActionType.HORIZONTAL,
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: config.tipMsg,
        hasArrow: true,
    },
    {
        name: horizontalLeft.id,
        tooltip: horizontalLeft.tipMsg,
        icon: <img src={horizontalLeft.icon} alt={''}/>,
    },
    {
        name: horizontalCenter.id,
        tooltip: horizontalCenter.tipMsg,
        icon: <img src={horizontalCenter.icon} alt={''}/>,
    },
    {
        name: horizontalRight.id,
        tooltip: horizontalRight.tipMsg,
        icon: <img src={horizontalRight.icon} alt={''}/>,
    },
    {
        name: horizontalJustify.id,
        tooltip: horizontalJustify.tipMsg,
        icon: <img src={horizontalJustify.icon} alt={''}/>,
    },
    {
        name: horizontalDistribute.id,
        tooltip: horizontalDistribute.tipMsg,
        icon: <img src={horizontalDistribute.icon} alt={''}/>,
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: i18n.t<string>('水平对齐'),
        preventDismiss: true,
    },
    {
        name: AlignType.HORIZONTAL_LEFT,
        content: i18n.t<string>('左对齐'),
    },
    {
        name: AlignType.HORIZONTAL_CENTER,
        content: i18n.t<string>('居中对齐'),
    },
    {
        name: AlignType.HORIZONTAL_RIGHT,
        content: i18n.t<string>('右对齐'),
    },
    {
        name: AlignType.HORIZONTAL_JUSTIFY,
        content: i18n.t<string>('两端对齐'),
    },
    {
        name: AlignType.HORIZONTAL_DISTRIBUTE,
        content: i18n.t<string>('分散对齐'),
    },
];
